import { useState, useEffect, useCallback } from 'react';
import { authenticatedFetch } from '../utils/fetch';

/**
 * Hook to fetch and manage the connection status between this
 * Shopify store and the ApparelHub platform.
 */
export default function useConnectionStatus() {
  const [isConnected, setIsConnected] = useState(false);
  const [accountEmail, setAccountEmail] = useState(null);
  const [storeName, setStoreName] = useState(null);
  const [loading, setLoading] = useState(true);
  // Billing context (apparelhub-shopify-app#12). Every field is optional on
  // purpose: apparelhub.ai may not yet be serving them, and a missing field
  // must degrade to hiding the billing card, never to a crash on a page that
  // also carries the connect flow.
  const [billing, setBilling] = useState({
    provider: null, tierName: null, tierSlug: null, planSelectionUrl: null,
  });

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authenticatedFetch('/api/connection-status');
      if (response.ok) {
        const data = await response.json();
        setIsConnected(!!data.connected);
        setAccountEmail(data.user_email || null);
        setStoreName(data.store_name || null);
        setBilling({
          provider: data.billing_provider || null,
          tierName: data.tier_name || null,
          tierSlug: data.tier_slug || null,
          planSelectionUrl: data.plan_selection_url || null,
        });
      } else {
        setIsConnected(false);
      }
    } catch (error) {
      console.error('Failed to fetch connection status:', error);
      setIsConnected(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { isConnected, accountEmail, storeName, billing, loading, refresh };
}
